/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_TimelineInputs */



/**
* | output |
* | --- |
* | "Interactive Timeline with audio waveform" |
*
* @param {Signup_Compare_TimelineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_timeline = /** @type {((inputs?: Signup_Compare_TimelineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_TimelineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Interactive Timeline with audio waveform")
	if (locale === "de") return /** @type {LocalizedString} */ ("Interactive Timeline with audio waveform")
	if (locale === "it") return /** @type {LocalizedString} */ ("Interactive Timeline with audio waveform")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Interactive Timeline with audio waveform")
	if (locale === "es") return /** @type {LocalizedString} */ ("Interactive Timeline with audio waveform")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Interactive Timeline with audio waveform")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Interactive Timeline with audio waveform")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Interactive Timeline with audio waveform")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Interactive Timeline with audio waveform")
	return /** @type {LocalizedString} */ ("Interactive Timeline with audio waveform")
});